// Velo API Reference: https://www.wix.com/velo/reference/api-overview/introduction

import wixData from 'wix-data';
import { multilingual } from 'wix-window-frontend';

$w.onReady(async () => {
    const currentLang = multilingual.currentLanguage;

    const result = await wixData.query("Blog/Posts")
        .eq("language", currentLang)
        .count();

    if (result === 0) {
        $w("#blogPostsSection").collapse();
    } else {
        $w("#blogPostsSection").expand();
    }
});